import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppleLogin from '../../assets/AppleLogin';
import GeetzLogin from '../../assets/GeetzLogo';
import GoogleLogin from '../../assets/GoogleLogin';
import Button from '../../components/Button';
import { useTheme } from '../../contexts/theme'; // Import useTheme hook

import {
  BackgroundImg,
  BottomContainer,
  ButtonsWrapper,
  FormBottomContainer,
  FormContainer,
  FormContentContainer,
  LogoWrapper,
  SignButton,
  SignInButtons,
  SubTitle,
  TextsContainer,
  Title,
} from './styles';

import inicio from '../../assets/LoginBackground/Artboard1.png';

export default function Inicio() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { themeColors } = useTheme();

  function handleCreateAccount() {
    navigate("/Cadastro")
  }

  function handleLogin() {
    navigate("/Login")
  }

  return (
    <>
      <BackgroundImg src={inicio} alt="Geetz Inicio" />
      <LogoWrapper>
        <GeetzLogin />
      </LogoWrapper>
      <FormContainer>
        <FormContentContainer>
          <TextsContainer>
            <Title>{t('inicio.title')}</Title>
            <SubTitle>{t('inicio.subtitle')}</SubTitle>
          </TextsContainer>
          <ButtonsWrapper>
            <Button
              height={"42"}
              theme="dark"
              text={t('inicio.register')}
              onClick={handleCreateAccount}
            />
            <Button
              height={"42"}
              theme="light"
              text={t('inicio.login')}
              onClick={handleLogin}
            />
          </ButtonsWrapper>
        </FormContentContainer>
      </FormContainer>
      <FormBottomContainer>
        <BottomContainer>
          <SubTitle>{t('inicio.download')}</SubTitle>
          <SignInButtons>
            <SignButton>
              <GoogleLogin />
            </SignButton>
            <SignButton>
              <AppleLogin />
            </SignButton>
          </SignInButtons>
        </BottomContainer>
      </FormBottomContainer>
    </>
  );
}